import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IManagerProfile } from 'src/app/core/models/i-manager-profile';
import { StatusConfig } from '../content-status-card/interfaces/status-config';
import { ProfileStatus } from 'src/app/manager-content/shared/enums/profile-status';

@Component({
  selector: 'app-profile-status-card',
  templateUrl: './profile-status-card.component.html',
  styleUrls: ['./profile-status-card.component.scss'],
})
export class ProfileStatusCardComponent {
  @Input() content!: IManagerProfile;
  @Input() isSaving!: boolean;
  @Input() isLoading!: boolean;
  @Input() isBioPopulated!: boolean;
  @Output() handleSave = new EventEmitter<void>();

  isEditing = false;

  STATUS_CONFIGS: {
    [key in ProfileStatus]: StatusConfig;
  } = {
    [ProfileStatus.Null]: {
      title: () => 'Read only',
      cssClasses: () => [
        'border-project-50',
        'bg-project-600',
        'text-project-50',
      ],
    },
    [ProfileStatus.Saved]: {
      title: () => 'Saved',
      cssClasses: () => [
        'border-project-3200',
        'bg-project-2800',
        'text-project-3200',
      ],
    },
    [ProfileStatus.Editing]: {
      title: () => 'Editing',
      cssClasses: () => [
        'border-project-1000',
        'bg-project-900',
        'text-project-1000',
      ],
    },
    [ProfileStatus.Published]: {
      title: () => 'Published',
      cssClasses: () => [
        'border-project-3300',
        'bg-project-3000',
        'text-project-3300',
      ],
    },
  };

  get statusConfigs(): StatusConfig {
    if (this.content?.status) {
      let config = this.STATUS_CONFIGS[this.content.status];

      if (!config) {
        config = this.STATUS_CONFIGS[ProfileStatus[this.content.status]];
      }

      this.isEditing = this.content?.status === ProfileStatus.Editing;

      return config;
    }

    return this.STATUS_CONFIGS[ProfileStatus.Null];
  }
}
